import { Grid } from '@mui/material';
import { styled } from '@mui/styles';
import { IJob, ITeam } from 'wisestep-api';
import { IUserDTO, WsColors } from 'wisestep-base';

export interface IAssignState {
  currentUserTeams?: ITeam[];
  currentUserTeamsArray?: INameAndId[];
  jobDetailsResponse?: IJob;
}
export interface INameAndId {
  name: string;
  id: string;
}
export interface IAssignCardProps {
  name: string;
  title: string;
  icon: React.ReactElement;
  jobId: string;
  disableButton?: boolean;
}
export interface TeamsState {
  workspaceTeams?: ITeam[];
  workAssignments?: IWorkAssignments;
}
export interface IAssignJobDrawerProps {
  name: string;
  openDrawer: boolean;
  jobId: string;
  onClose(): void;
  teams: TeamsState;
}
export interface IWorkAssignments {
  teams: ITeam[];
  recruiters: IUserDTO[];
  teamMembers: ITeamMembers[];
}

export interface ITeamMembers {
  teamId: string;
  memberEmail: string;
  roles: string[];
  role: string;
  user: IUserDTO;
  name: string;
}

export const defaultWorkAssignments: IWorkAssignments = {
  teams: [],
  teamMembers: [],
  recruiters: [],
};

export const StyledFooter = styled(Grid)(() => ({
  position: 'fixed',
  bottom: '10px',
  textAlign: 'center',
  right: '5px',
  justifyContent: 'flex-end',
  width: '29vw',
  backgroundColor: WsColors.White,
}));
